RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.SocialPosts = window.createMarionetteApp();
    app.name = 'socialPosts';
});
